import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { Autocomplete } from "@mui/material";
import { useParams } from "react-router-dom";

const EditCampaignAssociation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [company, setCompany] = useState();
  const [companyList, setCompanyList] = useState([]);
  const [campaign, setCampaign] = useState();
  const [campaignList, setCampaignList] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await CrudService.getCampaignAssociationCompany();
        setCompanyList(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
    (async () => {
      try {
        const response = await CrudService.getAllCampaign();
        setCampaignList(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
  }, []);

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        const response = await CrudService.getCampaignAssociation(id);
        if (response.data) {
          const { CampaignCompany, Campaign } = response.data;
          setCompany(CampaignCompany);
          setCampaign(Campaign);
        }
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
  }, [id]);

  const submitHandler = async (e) => {
    e.preventDefault();

    const data = {
      company_id: company?.company_id,
      campaign_id: campaign?.campaign_id,
    };
    try {
      await CrudService.updateCampaignAssociation(id, data);
      navigate("/campaign/association", {
        state: {
          value: true,
          text: "The association was successfully updated",
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  Edit Campaign Association
                </MDTypography>
              </MDBox>
            </MDBox>
            <Card>
              <MDBox component="form" method="POST" onSubmit={submitHandler}>
                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                  <Autocomplete
                    sx={{ marginTop: "0.5rem" }}
                    defaultValue=""
                    options={companyList}
                    getOptionLabel={(option) => option.company_name ?? ""}
                    value={company ?? ""}
                    onChange={(event, newCompany) => {
                      setCompany(newCompany);
                    }}
                    renderInput={(params) => (
                      <FormField
                        {...params}
                        label="Company"
                        InputLabelProps={{ shrink: company }}
                        required
                      />
                    )}
                  />
                  <Autocomplete
                    sx={{ marginTop: "0.5rem" }}
                    defaultValue=""
                    options={campaignList}
                    getOptionLabel={(option) => option.name ?? ""}
                    value={campaign ?? ""}
                    onChange={(event, newCampaign) => {
                      setCampaign(newCampaign);
                    }}
                    renderInput={(params) => (
                      <FormField
                        {...params}
                        label="Campaign"
                        InputLabelProps={{ shrink: campaign }}
                        required
                      />
                    )}
                  />

                  <MDBox
                    ml="auto"
                    mt={4}
                    mb={2}
                    display="flex"
                    justifyContent="flex-end"
                  >
                    <MDBox mx={2}>
                      <MDButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        px={2}
                        mx={2}
                        onClick={() =>
                          navigate("/campaign/association", {
                            state: { value: false, text: "" },
                          })
                        }
                      >
                        Back
                      </MDButton>
                    </MDBox>
                    <MDButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      type="submit"
                    >
                      Update
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default EditCampaignAssociation;
